import React, { useMemo, useState } from "react";
import { Menu, MenuItem } from "@blueprintjs/core";
import { Popover } from "@blueprintjs/core";
import { useSelector } from "react-redux";
import classNames from "classnames";
import Button from "../../components/Button";
import { mergeRefs } from "utils/data";
import { checkPressedEnter } from "utils/keyboard";
import { useOnScrollPopoverStateListener } from "hooks/useScrollDebounceListener";
import { scrollElementSelector } from "store/global/global.selectors";
import * as styles from "./styles.module.scss";
const DropDownButton = ({ buttonProps, editable = true, placement = "bottom-end", items = [], minimal = true, menuProps: { className: menuClassName, ...menuProps } = {}, scrollElement, ...popoverProps }) => {
    const elementScroll = useSelector(scrollElementSelector(scrollElement));
    const [popoverRef, setPopoverRef] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false);
    const button = useMemo(() => (React.createElement(Button, { ...buttonProps, onClick: (e) => {
            setMenuOpen(true);
            buttonProps.onClick?.(e);
        } })), [buttonProps]);
    useOnScrollPopoverStateListener(menuOpen, setMenuOpen, popoverRef, elementScroll);
    return items.length > 0 ? (React.createElement(Popover, { ...popoverProps, popoverRef: mergeRefs(setPopoverRef, popoverProps?.popoverRef), minimal: minimal, placement: placement, isOpen: editable && menuOpen, targetTagName: "div", content: React.createElement(Menu, { className: classNames(menuClassName, styles.menu), ...menuProps }, items.map(({ className, onClick, ...item }) => (React.createElement(MenuItem, { ...item, key: item.text?.toString(), className: classNames(className, styles.item), onClick: (e) => {
                onClick?.(e);
                setMenuOpen(false);
            }, onKeyDown: (e) => {
                if (checkPressedEnter(e) && onClick) {
                    onClick(e);
                }
            } })))), onInteraction: (nextOpenState) => menuOpen && setMenuOpen(nextOpenState) }, button)) : (button);
};
export default DropDownButton;
